<div class="card-container">
    <mat-card appearance="outlined">
        <mat-card-header>
            <mat-card-title>
                <mat-icon class="minster-primary">{{ _icon }}</mat-icon>
                <span class="title minster-primary">{{ _title }}</span>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <ng-content ></ng-content>
        </mat-card-content>
    </mat-card>

</div>
